/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiReport,
    ApiReportFromJSON,
    ApiReportFromJSONTyped,
    ApiReportToJSON,
} from './ApiReport';

/**
 * 
 * @export
 * @interface ApiResultOfApiReport
 */
export interface ApiResultOfApiReport {
    /**
     * 
     * @type {ApiReport}
     * @memberof ApiResultOfApiReport
     */
    data?: ApiReport;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfApiReport
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfApiReport
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfApiReport
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfApiReport
     */
    result?: ApiResultOfApiReportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfApiReportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfApiReportFromJSON(json: any): ApiResultOfApiReport {
    return ApiResultOfApiReportFromJSONTyped(json, false);
}

export function ApiResultOfApiReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfApiReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ApiReportFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfApiReportToJSON(value?: ApiResultOfApiReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ApiReportToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

